// normalize CSS across browsers
import 'normalize.css';

// import fonts
import './src/styles/fonts.css';

// import Tailwind CSS
import './src/styles/tailwind.css';

// custom CSS styles
import './src/styles/common.scss';

// custom global CSS styles
import './src/styles/custom.scss';

import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ApolloProvider } from '@apollo/client';
import client from './src/apollo/client';

export const wrapRootElement = ({ element }) => (
  <HelmetProvider>
    <ApolloProvider client={client}>{element}</ApolloProvider>
  </HelmetProvider>
);
